module.exports = __webpack_public_path__ + "img/card.ac40e5be.png";